const RDA_DASHBOARD_CONSTANTS = {
  GETTING_OVERALL_TXNS: 'GETTING_OVERALL_TXNS',
  GET_OVERALL_TXNS_SUCCESS: 'GET_OVERALL_TXNS_SUCCESS',
  GET_OVERALL_TXNS_FAIL: 'GET_OVERALL_TXNS_FAIL',
  GETTING_YBL_PARTNER_TXNS: 'GETTING_YBL_PARTNER_TXNS',
  GET_YBL_PARTNER_TXNS_SUCCESS: 'GET_YBL_PARTNER_TXNS_SUCCESS',
  GET_YBL_PARTNER_TXNS_FAIL: 'GET_YBL_PARTNER_TXNS_FAIL',
  GETTING_TL_TXNS: 'GETTING_TL_TXNS',
  GET_TL_TXNS_FAIL: 'GET_TL_TXNS_FAIL',
  GET_TL_TXNS_SUCCESS: 'GET_TL_TXNS_SUCCESS',
  GETTING_CB_TXNS: 'GETTING_CB_TXNS',
  GET_CB_TXNS_SUCCESS: 'GET_CB_TXNS_SUCCESS',
  GET_CB_TXNS_FAIL: 'GET_CB_TXNS_FAIL',

  GETTING_HOLIDAY_DATA: 'GETTING_HOLIDAY_DATA',
  GETTING_HOLIDAY_DATA_SUCCESS: 'GETTING_HOLIDAY_DATA_SUCCESS',
  GETTING_HOLIDAY_DATA_FAILURE: 'GETTING_HOLIDAY_DATA_FAILURE',

  GETTING_CLEAR_BANK_ACCOUNT_DETAILS: 'GETTING_CLEAR_BANK_ACCOUNT_DETAILS',
  GETTING_CLEAR_BANK_ACCOUNT_DETAILS_SUCCESS:
    'GETTING_CLEAR_BANK_ACCOUNT_DETAILS_SUCCESS',
  GETTING_CLEAR_BANK_ACCOUNT_DETAILS_FAIL:
    'GETTING_CLEAR_BANK_ACCOUNT_DETAILS_FAIL',
  GETTING_YBL_DOWNTIME_LIST: 'GETTING_YBL_DOWNTIME_LIST',
  GET_YBL_DOWNTIME_LIST_SUCCESS: 'GET_YBL_DOWNTIME_LIST_SUCCESS',
  GET_YBL_DOWNTIME_LIST_FAIL: 'GET_YBL_DOWNTIME_LIST_FAIL',
  GETTING_FULFILLMENT_BALANCES: 'GETTING_FULFILLMENT_BALANCES',
  GET_FULFILLMENT_BALANCES_SUCCESS: 'GET_FULFILLMENT_BALANCES_SUCCESS',
  GET_FULFILLMENT_BALANCES_FAIL: 'GET_FULFILLMENT_BALANCES_FAIL',
  // Routing Configs
  GETTING_ROUTING_CONFIGS: 'GETTING_ROUTING_CONFIGS',
  GET_ROUTING_CONFIGS_SUCCESS: 'GET_ROUTING_CONFIGS_SUCCESS',
  GET_ROUTING_CONFIGS_FAIL: 'GET_ROUTING_CONFIGS_FAIL',
  UPDATING_ROUTING_CONFIGS: 'UPDATING_ROUTING_CONFIGS',
  UPDATING_ROUTING_CONFIGS_SUCCESS: 'UPDATING_ROUTING_CONFIGS_SUCCESS',
  UPDATING_ROUTING_CONFIGS_FAIL: 'UPDATING_ROUTING_CONFIGS_FAIL',
  GETTING_ROUTING_CONFIG_META: 'GETTING_ROUTING_CONFIG_META',
  GET_ROUTING_CONFIG_META_SUCCESS: 'GET_ROUTING_CONFIG_META_SUCCESS',
  GET_ROUTING_CONFIG_META_FAIL: 'GET_ROUTING_CONFIG_META_FAIL',
  GETTING_META_DATA: 'GETTING_META_DATA',
  GET_META_DATA_SUCCESS: 'GET_META_DATA_SUCCESS',
  GET_META_DATA_FAIL: 'GET_META_DATA_FAIL',
};

export default RDA_DASHBOARD_CONSTANTS;
